<template>
    <div>
        <form @submit.prevent="save" class="ortic-form-horizontal mb-10" ref="form">
            <o-card :title="$t('sandoz.kick_out')">
                <b-row>
                    <b-col>
                        <o-form-group :label="$t('sandoz.whs_customer_localkey')" :class="item.localkey_address ? 'mb-1': ''">
                            <b-input-group>
                                <input v-model="item.whs_customer_localkey" type="text" class="form-control" disabled>
                                <b-input-group-append>
                                    <b-btn variant="primary" @click.prevent="$refs.addLocalKeyModel.show()">
                                        <fa icon="ellipsis-h"/>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </o-form-group>
                        <o-form-group v-if="item.localkey_address" class="text-muted"
                                      :label="$t('sandoz.whs_customer_address_zip')">
                            <b-input-group class="pt-1">
                                {{ item.localkey_address + ', ' + item.localkey_zip }}
                            </b-input-group>
                        </o-form-group>

                        <o-form-group :label="$t('sandoz.mst_customer_localkey')" class="d-none">
                            <input v-model="item.mst_customer_localkey" type="text" class="form-control">
                        </o-form-group>

                        <o-form-group :label="$t('sandoz.ean')" :class="ean_customer ? 'mb-1': ''">
                            <b-input-group>
                                <input v-model="item.ean" type="text" class="form-control"
                                       v-on:blur="customerName($event.target.value)" disabled>
                                <b-input-group-append>
                                    <b-btn variant="primary" @click.prevent="$refs.addEanModel.show()">
                                        <fa icon="ellipsis-h"/>
                                    </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </o-form-group>
                        <o-form-group v-if="ean_customer" class="text-muted" :label="$t('sandoz.mst_customer_name')">
                            <b-input-group class="pt-1">
                                {{ ean_customer }}
                            </b-input-group>
                        </o-form-group>
                        <o-monthpicker :errorField="'valid_from'" :label="$t('sandoz.valid_from')"
                                       v-model="item.valid_from"/>
                        <o-monthpicker :errorField="'valid_to'" :label="$t('sandoz.valid_to')"
                                       v-model="item.valid_to"  day-of-the-month="last"/>
                    </b-col>
                    <b-col>
                        <o-textarea v-model="item.comment" :label="$t('sandoz.comment')"></o-textarea>
                    </b-col>
                </b-row>
            </o-card>
        </form>
        <o-action-toolbar>
            <div class="d-flex w-100">
                <o-button variant="outline-primary" @click.prevent="back">{{$t('core.back')}}</o-button>
                <o-button variant="primary" class="ml-auto" :loading="saving" @click.prevent="save">
                    {{$t('core.save')}}
                </o-button>
            </div>
        </o-action-toolbar>
        <b-modal id="modal-ean" ref="addEanModel" :title="$t('sandoz.ean')" :ok-only="true" size="lg"
                 :ok-title="$t('core.cancel')">
            <o-table url="/api/sandoz/wholesaler_customer_master" title="" ref="eanList" :enable-new="false"
                     :enable-delete="false" :enable-edit="false" :shadow="false">
                <template slot="filter">
                    <o-filter v-on:filter-updated="(filters) => $refs.eanList.setFilters(filters)">
                        <o-filter-text :title="$t('sandoz.ean')" column="ean"
                                     :show-button="true"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.mst_customer_name')" column="mst_customer_name"
                                       :show-button="true" :prepend-percentage="true"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.mst_customer_address')" column="mst_customer_address"
                                       :show-button="true" :prepend-percentage="true"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.mst_customer_zip')" column="mst_customer_zip"
                                       :show-button="true"></o-filter-text>
                    </o-filter>
                </template>
                <template slot="head">
                    <th>{{$t('sandoz.ean')}}</th>
                    <th>{{$t('sandoz.mst_customer_name')}}</th>
                    <th>{{$t('sandoz.mst_customer_type')}}</th>
                    <th>{{$t('sandoz.mst_customer_address')}}</th>
                    <th>{{$t('sandoz.mst_customer_zip')}}</th>
                </template>
                <template slot="body" slot-scope="eanProps">
                    <td>{{ eanProps.item.ean }}</td>
                    <td>{{ eanProps.item.mst_customer_name }}</td>
                    <td>{{ eanProps.item.mst_customer_type }}</td>
                    <td>{{ eanProps.item.mst_customer_address }}</td>
                    <td>{{ eanProps.item.mst_customer_zip }}</td>
                </template>
                <template slot="body-controls" slot-scope="eanProps">
                    <td class="text-right">
                        <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                            <b-btn variant="primary" @click="addEan(eanProps.item)">
                                <fa icon="arrow-right"/>
                            </b-btn>
                        </div>
                    </td>
                </template>
            </o-table>
        </b-modal>
        <b-modal id="modal-local-key" ref="addLocalKeyModel" :title="$t('sandoz.whs_customer_localkey')"
                 :ok-only="true" size="xl" :ok-title="$t('core.cancel')">
            <o-table url="/api/sandoz/wholesaler_customer_source" title="" ref="localList" :enable-new="false"
                     :enable-delete="false" :enable-edit="false" :shadow="false">
                <template slot="filter">
                    <o-filter v-on:filter-updated="(filters) => $refs.localList.setFilters(filters)">
                        <o-filter-text :title="$t('sandoz.whs_customer_name')" column="whs_customer_name"
                                       :show-button="true" :prepend-percentage="true"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.whs_customer_address')" column="whs_customer_address"
                                       :show-button="true" :prepend-percentage="true"></o-filter-text>
                        <o-filter-text :title="$t('sandoz.whs_customer_zip')" column="whs_customer_zip"
                                       :show-button="true"></o-filter-text>
                    </o-filter>
                </template>
                <template slot="head">
                    <th>{{$t('sandoz.wholesaler_code')}}</th>
                    <th>{{$t('sandoz.ean')}}</th>
                    <th>{{$t('sandoz.whs_customer_name')}}</th>
                    <th>{{$t('sandoz.whs_customer_localkey')}}</th>
                    <th>{{$t('sandoz.whs_customer_address')}}</th>
                    <th>{{$t('sandoz.mst_customer_zip')}}</th>
                </template>
                <template slot="body" slot-scope="localKeyProps">
                    <td>{{ localKeyProps.item.wholesaler_code }}</td>
                    <td>{{ localKeyProps.item.whs_ean }}</td>
                    <td>{{ localKeyProps.item.whs_customer_name }}</td>
                    <td>{{ localKeyProps.item.whs_customer_localkey }}</td>
                    <td>{{ localKeyProps.item.whs_customer_address }}</td>
                    <td>{{ localKeyProps.item.whs_customer_zip }}</td>
                </template>
                <template slot="body-controls" slot-scope="localKeyProps">
                    <td class="text-right">
                        <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                            <b-btn variant="primary" @click="addLocalKey(localKeyProps.item)">
                                <fa icon="arrow-right"/>
                            </b-btn>
                        </div>
                    </td>
                </template>
            </o-table>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .mb-10 {
        margin-bottom: 10rem;
    }
</style>

<script>
  import axios from 'axios'
  import {i18n} from '~/plugins/i18n'

  export default {
    methods: {
      save() {
        var self = this
        var url = '/api/sandoz/wholesaler_kickout_match/new'
        var route = this.$route

        if (url.indexOf('/new') > 0 && 'id' in self.item) {
            url = url.replace('/new', '/' + self.item.id)
        }

        var root = self.$root
        self.saving = true

        axios
            .post(url, self.item)
            .then((response) => {
                self.item = response.data

                if ('id' in response.data) {
                    route.params.id = response.data.id
                }

                this.$notify({
                    title: this.$i18n.t('core.saved'),
                    text: this.$i18n.t('core.saved_text')
                })

                var elements = document.querySelectorAll('.has-error')
                elements.forEach((element) => {
                    element.classList.remove('has-error')
                })

                root.errors = {}
                self.saving = false
            })
            .catch((error) => {
                self.saving = false
                if (error.response.status === 422 && 'data' in error.response && 'errors' in error.response.data) {
                    Object.entries(error.response.data.errors).forEach(function (x) {
                      self.$notify({
                        title: self.$i18n.t('core.validation_error'),
                        text: self.$i18n.t('core.validation_error_text', {message: x[1][0]}),
                        type: 'error'
                      })
                    })

                    if ('data' in error.response && 'errors' in error.response.data) {
                      root.errors = error.response.data.errors
                    }
                } else if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
                    self.$notify({
                        title: self.$i18n.t('core.validation_error'),
                        text: self.$i18n.t('core.validation_error_text', {message: error.response.data.message}),
                        type: 'error'
                    })
                    if ('data' in error.response && 'errors' in error.response.data) {
                        root.errors = error.response.data.errors
                    }
                } else {
                    self.$notify({
                        title: self.$i18n.t('core.save_error'),
                        text: self.$i18n.t('core.save_error_text', {url: url}),
                        type: 'error'
                    })
                }
            })
      },
      back() {
        this.$router.back()
      },
      load() {
        var url = '/api/sandoz/wholesaler_kickout_report/' + this.$route.params.id + '?include=localkey'
        return axios
            .get(url)
            .then((response) => {
                this.$set(this.item, 'whs_customer_localkey', response.data ? response.data.whs_customer_localkey : null)
                this.$set(this.item, 'localkey_address', response.data && response.data.localkey ? response.data.localkey.whs_customer_address : null)
                this.$set(this.item, 'localkey_zip', response.data && response.data.localkey ? response.data.localkey.whs_customer_zip : null)
            })
            .catch((error) => {
                this.$notify({
                    title: this.$i18n.t('core.load_error'),
                    text: this.$i18n.t('core.load_error_text', {url: url}),
                    type: 'error'
                })
            })
      },
        addLocalKey(localKey) {
        this.$set(this.item, 'whs_customer_localkey', localKey.whs_customer_localkey)
        this.$set(this.item, 'localkey_address', localKey.whs_customer_address)
        this.$set(this.item, 'localkey_zip', localKey.whs_customer_zip)
        this.$refs.addLocalKeyModel.hide()
      },
      addEan(ean) {
        this.$set(this.item, 'mst_customer_localkey', ean.mst_customer_localkey)
        this.$set(this.item, 'ean', ean.ean)
        this.ean_customer = ean.mst_customer_name
        this.$refs.addEanModel.hide()
      },
      customerName(value) {
        if(!value) {
          this.ean_customer =  null
          return
        }

        var url = '/api/sandoz/wholesaler_customer_master?filter[ean]=' + value
        axios
          .get(url)
          .then((response) => {
              this.ean_customer =  response.data.data[0] ? response.data.data[0].mst_customer_name : null
          })
          .catch((error) => {
            this.$notify({
              title: this.$i18n.t('core.load_error'),
              text: this.$i18n.t('core.load_error_text', {url: url}),
              type: 'error'
            })
          })
      },
      whsAddressZip(value) {
        if(!value) {
            this.$set(this.$refs.form.item, 'localkey_address', null)
            this.$set(this.$refs.form.item, 'localkey_zip', null)
            return
        }

        var url = '/api/sandoz/wholesaler_customer_source?filter[whs_customer_localkey]=' + value
        axios
            .get(url)
            .then((response) => {
                this.$set(this.item, 'localkey_address', response.data.data[0] ? response.data.data[0].whs_customer_address : null)
                this.$set(this.item, 'localkey_zip', response.data.data[0] ? response.data.data[0].whs_customer_zip : null)
            })
            .catch((error) => {})
      }
    },
    created() {
      this.load()
    },
    data: () => ({
      item: {},
      saving: false,
      ean_customer: null
    })
  }

</script>
